import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "masters-qualifications-info" }
const _hoisted_2 = { class: "cta" }
const _hoisted_3 = { main: "" }
const _hoisted_4 = { class: "header" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "main-content" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "ticket-seats arrow-box" }
const _hoisted_9 = { class: "score-seats arrow-box" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "ranking-list arrow-box three-4th" }
const _hoisted_12 = { class: "qualification arrow-box" }
const _hoisted_13 = { class: "master-box" }
const _hoisted_14 = { class: "entry-fee arrow-box" }
const _hoisted_15 = { class: "wildcard-content" }

import { ref, computed } from 'vue'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { gdcConverter } from '@gd/currency-converter'
import { marked } from 'marked'
import { ACTION } from '@gd/tracking'
import { track } from '@/lib/track'


export default /*@__PURE__*/_defineComponent({
  __name: 'CMastersQualificationInfo',
  setup(__props) {

const route = useRoute()
const { t } = useI18n()
const showQualificationInfoModal = ref(false)
const realPrize = computed(() => {
  // Format value only with EUR !!!
  return gdcConverter('125000', { gdc: 'EUR' })
})
const infoText = computed(() => {
  return marked(t('masterQualification.wildcard.text'))
})

function showModal() {
  track({
    id: 'master-qualification-modal',
    path: route.fullPath,
    action: ACTION.show,
  })
  showQualificationInfoModal.value = true
}

function text(key: string) {
  return marked(
    t('masterQualification.diagram.' + key, {
      numberOfTournaments: 45,
      finalPrize: realPrize.value,
      firstPrize: gdcConverter('25000', { gdc: 'EUR' }),
      rankPrize: gdcConverter('10000', { gdc: 'EUR' }),
      topRankSeatsNumber: 30,
      topRankPrizesNumber: 100,
      topMasterSeatsNumber: 3,
      topMasterPrizesNumber: 300,
      qualificationNumber: 135,
      maxPrize: gdcConverter('270000', { gdc: 'EUR' }),
      tournamentPrizePool: gdcConverter('6000', { gdc: 'EUR' }),
      entryFee: gdcConverter('10', { gdc: 'EUR' }),
      tournamentTickets: 3,
      calculatedGames: 6,
    })
  )
}

return (_ctx: any,_cache: any) => {
  const _component_t_text = _resolveComponent("t-text")!
  const _component_t_toggle_box = _resolveComponent("t-toggle-box")!
  const _component_modal_content = _resolveComponent("modal-content")!
  const _component_modal_layout = _resolveComponent("modal-layout")!
  const _component_modal_app = _resolveComponent("modal-app")!
  const _component_gd_modal = _resolveComponent("gd-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        href: "javascript:void(0)",
        onClick: showModal,
        "data-qe-id": "qualification-info-link"
      }, _toDisplayString(_ctx.$t('masterQualification.main.link', { realPrize: realPrize.value })), 1)
    ]),
    _renderSlot(_ctx.$slots, "activator"),
    (showQualificationInfoModal.value)
      ? (_openBlock(), _createBlock(_component_gd_modal, {
          key: 0,
          onCloseBG: _cache[0] || (_cache[0] = ($event: any) => (showQualificationInfoModal.value = false)),
          onCloseESC: _cache[1] || (_cache[1] = ($event: any) => (showQualificationInfoModal.value = false)),
          onClose: _cache[2] || (_cache[2] = ($event: any) => (showQualificationInfoModal.value = false))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_modal_app, {
              l: "",
              "data-qe-id": "qualification-info-modal"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_modal_layout, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_modal_content, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          _createElementVNode("div", _hoisted_4, [
                            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "trophy" }, null, -1)),
                            _createElementVNode("div", {
                              class: "content",
                              innerHTML: text('final')
                            }, null, 8, _hoisted_5)
                          ]),
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                              _createElementVNode("div", _hoisted_8, [
                                _createVNode(_component_t_text, {
                                  class: "master-box arrow centered",
                                  innerHTML: text('qualificationFinal')
                                }, null, 8, ["innerHTML"])
                              ]),
                              _createElementVNode("div", _hoisted_9, [
                                _createVNode(_component_t_text, {
                                  class: "master-box arrow centered",
                                  innerHTML: text('rankingListFinal')
                                }, null, 8, ["innerHTML"])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "ranking-list arrow-box one-4th" }, null, -1)),
                              _createElementVNode("div", _hoisted_11, [
                                _createVNode(_component_t_text, {
                                  class: "master-box",
                                  innerHTML: text('rankingList')
                                }, null, 8, ["innerHTML"])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("div", _hoisted_13, [
                                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "arrow-extension-box" }, null, -1)),
                                _createVNode(_component_t_text, {
                                  innerHTML: text('masterDetails')
                                }, null, 8, ["innerHTML"])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_14, [
                              _createVNode(_component_t_text, {
                                class: "master-box",
                                innerHTML: text('entryFee')
                              }, null, 8, ["innerHTML"])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_t_toggle_box, {
                            title: _ctx.$t('masterQualification.wildcard.title')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_t_text, { innerHTML: infoText.value }, null, 8, ["innerHTML"])
                            ]),
                            _: 1
                          }, 8, ["title"])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})